import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withData from 'components/withData';

import { PermissionsContext } from '.';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		permissions: null,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				permissions: response.data,
			});
		}
	}

	render() {
		return (
			<PermissionsContext.Provider
				value={{
					...this.state,
					refetch: this.props.response.refetch,
				}}
			>
				{this.state.permissions || this.props.response.success
					? this.props.children
					: null}
			</PermissionsContext.Provider>
		);
	}
}

export const PermissionsContextProvider = withRouter(
	withData('/mypermissions')(Provider)
);
